import { render, staticRenderFns } from "./SuricataConfigModal.vue?vue&type=template&id=405f4588&scoped=true&"
import script from "./SuricataConfigModal.vue?vue&type=script&lang=js&"
export * from "./SuricataConfigModal.vue?vue&type=script&lang=js&"
import style0 from "./SuricataConfigModal.vue?vue&type=style&index=0&id=405f4588&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405f4588",
  null
  
)

export default component.exports